// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box[data-v-81616cce]{margin:25px;text-align:left}.button[data-v-81616cce]{background-color:#4abca5;color:#fff;margin-right:20px}.flex-container[data-v-81616cce]{display:-webkit-box;display:-ms-flexbox;display:flex}.form-shadow[data-v-81616cce],.form-shadow-box[data-v-81616cce]{-webkit-box-shadow:rgba(74,188,165,.35) 0 5px 15px;box-shadow:0 5px 15px rgba(74,188,165,.35)}.form-shadow-box[data-v-81616cce]{padding:10px;border-radius:25px}", ""]);
// Exports
module.exports = exports;
